import React, { useState, useEffect } from 'react';
import { 
  FiUser, 
  FiUsers, 
  FiFileText, 
  FiEdit3, 
  FiPrinter, 
  FiEye, 
  FiPlus, 
  FiLogOut,
  FiSearch,
  FiFilter,
  FiDownload,
  FiCheck,
  FiX,
  FiClock,
  FiAlertCircle,
  FiSettings
} from 'react-icons/fi';

const AdminPanel = () => {
  // Estados principais
  const [currentUser, setCurrentUser] = useState({ name: 'Admin', role: 'admin' });
  const [activeTab, setActiveTab] = useState('applications');
  const [applications, setApplications] = useState([
    {
      id: '1',
      nomeCompleto: 'João Silva Santos',
      email: 'joao.silva@email.com',
      curso: 'Preparatório para Engenharia Informática',
      dataNascimento: '1995-05-15',
      telefone: '923456789',
      docIdentificacao: '123456789LA001',
      genero: 'Masculino',
      turno: 'Manhã',
      status: 'new',
      paymentStatus: 'pending',
      createdAt: new Date('2024-08-01'),
      updatedAt: new Date('2024-08-01')
    },
    {
      id: '2',
      nomeCompleto: 'Maria José Fernandes',
      email: 'maria.jose@email.com',
      curso: 'Preparatório para Psicologia',
      dataNascimento: '1997-09-22',
      telefone: '912345678',
      docIdentificacao: '987654321LA002',
      genero: 'Feminino',
      turno: 'Manhã',
      status: 'approved',
      paymentStatus: 'paid',
      createdAt: new Date('2024-07-28'),
      updatedAt: new Date('2024-07-30')
    }
  ]);
  const [users, setUsers] = useState([
    { id: '1', name: 'Admin Principal', email: 'admin@atlantida.ao', role: 'admin', active: true },
    { id: '2', name: 'Funcionário João', email: 'joao@atlantida.ao', role: 'employee', active: true }
  ]);
  
  // Estados para modais e formulários
  const [showUserModal, setShowUserModal] = useState(false);
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [newUser, setNewUser] = useState({ name: '', email: '', role: 'employee' });
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [paymentFilter, setPaymentFilter] = useState('all');

  // Funções utilitárias
  const formatDate = (date) => {
    return new Intl.DateTimeFormat('pt-AO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(date));
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'new': return '#2196F3';
      case 'approved': return '#4CAF50';
      case 'rejected': return '#f44336';
      case 'pending': return '#FF9800';
      default: return '#757575';
    }
  };

  const getPaymentStatusColor = (status) => {
    switch(status) {
      case 'paid': return '#4CAF50';
      case 'pending': return '#FF9800';
      case 'overdue': return '#f44336';
      default: return '#757575';
    }
  };

  // Filtros
  const filteredApplications = applications.filter(app => {
    const matchesSearch = app.nomeCompleto.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         app.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         app.curso.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || app.status === statusFilter;
    const matchesPayment = paymentFilter === 'all' || app.paymentStatus === paymentFilter;
    
    return matchesSearch && matchesStatus && matchesPayment;
  });

  // Handlers
  const handleAddUser = () => {
    if (newUser.name && newUser.email) {
      const user = {
        id: Date.now().toString(),
        ...newUser,
        active: true
      };
      setUsers([...users, user]);
      setNewUser({ name: '', email: '', role: 'employee' });
      setShowUserModal(false);
    }
  };

  const handleUpdatePaymentStatus = (appId, newStatus) => {
    setApplications(prev => prev.map(app => 
      app.id === appId 
        ? { ...app, paymentStatus: newStatus, updatedAt: new Date() }
        : app
    ));
  };

  const handleUpdateApplicationStatus = (appId, newStatus) => {
    setApplications(prev => prev.map(app => 
      app.id === appId 
        ? { ...app, status: newStatus, updatedAt: new Date() }
        : app
    ));
  };

  const handlePrintReceipt = (application) => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Recibo de Inscrição - ${application.nomeCompleto}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; border-bottom: 2px solid #00761F; padding-bottom: 20px; margin-bottom: 30px; }
            .content { margin-bottom: 30px; }
            .row { display: flex; justify-content: space-between; margin-bottom: 10px; }
            .label { font-weight: bold; }
            .footer { text-align: center; margin-top: 40px; font-size: 12px; color: #666; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Instituto Superior Politécnico Atlântida</h1>
            <h2>Recibo de Inscrição</h2>
          </div>
          <div class="content">
            <div class="row"><span class="label">Nome Completo:</span> ${application.nomeCompleto}</div>
            <div class="row"><span class="label">Email:</span> ${application.email}</div>
            <div class="row"><span class="label">Telefone:</span> ${application.telefone}</div>
            <div class="row"><span class="label">Documento:</span> ${application.docIdentificacao}</div>
            <div class="row"><span class="label">Curso:</span> ${application.curso}</div>
            <div class="row"><span class="label">Turno:</span> ${application.turno}</div>
            <div class="row"><span class="label">Data de Inscrição:</span> ${formatDate(application.createdAt)}</div>
            <div class="row"><span class="label">Status:</span> ${application.status}</div>
            <div class="row"><span class="label">Status de Pagamento:</span> ${application.paymentStatus}</div>
          </div>
          <div class="footer">
            <p>Este documento comprova a inscrição no Instituto Superior Politécnico Atlântida</p>
            <p>Data de emissão: ${formatDate(new Date())}</p>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  const handlePrintPaymentProof = (application) => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Comprovativo de Pagamento - ${application.nomeCompleto}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; border-bottom: 2px solid #00761F; padding-bottom: 20px; margin-bottom: 30px; }
            .content { margin-bottom: 30px; }
            .row { display: flex; justify-content: space-between; margin-bottom: 10px; }
            .label { font-weight: bold; }
            .amount { font-size: 18px; font-weight: bold; color: #00761F; }
            .footer { text-align: center; margin-top: 40px; font-size: 12px; color: #666; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Instituto Superior Politécnico Atlântida</h1>
            <h2>Comprovativo de Pagamento</h2>
          </div>
          <div class="content">
            <div class="row"><span class="label">Nome do Estudante:</span> ${application.nomeCompleto}</div>
            <div class="row"><span class="label">Curso:</span> ${application.curso}</div>
            <div class="row"><span class="label">Documento:</span> ${application.docIdentificacao}</div>
            <div class="row"><span class="label">Data de Pagamento:</span> ${formatDate(application.updatedAt)}</div>
            <div class="row"><span class="label">Valor Pago:</span> <span class="amount">25.000,00 Kz</span></div>
            <div class="row"><span class="label">Referência:</span> ISPA${application.id.padStart(6, '0')}</div>
            <div class="row"><span class="label">Status:</span> ${application.paymentStatus}</div>
          </div>
          <div class="footer">
            <p>Este documento comprova o pagamento da inscrição</p>
            <p>Data de emissão: ${formatDate(new Date())}</p>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f5f5f5', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}>
      {/* Sidebar */}
      <div style={{ 
        width: '280px', 
        backgroundColor: '#00761F', 
        color: 'white', 
        padding: '20px',
        boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
          <h2 style={{ margin: '0 0 5px 0', fontSize: '1.4rem' }}>Instituto Atlântida</h2>
          <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9rem' }}>Painel Administrativo</p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <FiUser size={20} style={{ marginRight: '10px' }} />
            <div>
              <div style={{ fontWeight: '600' }}>{currentUser.name}</div>
              <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>{currentUser.role === 'admin' ? 'Administrador' : 'Funcionário'}</div>
            </div>
          </div>
        </div>

        <nav>
          <div 
            onClick={() => setActiveTab('applications')}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              borderRadius: '8px',
              cursor: 'pointer',
              backgroundColor: activeTab === 'applications' ? 'rgba(255,255,255,0.1)' : 'transparent',
              marginBottom: '8px',
              transition: 'background-color 0.2s'
            }}
          >
            <FiFileText size={18} style={{ marginRight: '12px' }} />
            Candidaturas
          </div>
          
          {currentUser.role === 'admin' && (
            <div 
              onClick={() => setActiveTab('users')}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: activeTab === 'users' ? 'rgba(255,255,255,0.1)' : 'transparent',
                marginBottom: '8px',
                transition: 'background-color 0.2s'
              }}
            >
              <FiUsers size={18} style={{ marginRight: '12px' }} />
              Utilizadores
            </div>
          )}
        </nav>

        <div style={{ position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
            borderRadius: '8px',
            cursor: 'pointer',
            backgroundColor: 'rgba(255,255,255,0.1)',
            transition: 'background-color 0.2s'
          }}>
            <FiLogOut size={18} style={{ marginRight: '12px' }} />
            Sair
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, padding: '30px' }}>
        {activeTab === 'applications' && (
          <div>
            {/* Header */}
            <div style={{ marginBottom: '30px' }}>
              <h1 style={{ color: '#333', margin: '0 0 10px 0', fontSize: '1.8rem' }}>Gestão de Candidaturas</h1>
              <p style={{ color: '#666', margin: 0 }}>Visualize e gerencie todas as candidaturas recebidas</p>
            </div>

            {/* Stats Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
              <div style={{ 
                backgroundColor: 'white', 
                padding: '20px', 
                borderRadius: '12px', 
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                border: '1px solid #e0e0e0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#00761F' }}>{applications.length}</div>
                    <div style={{ color: '#666', fontSize: '0.9rem' }}>Total de Candidaturas</div>
                  </div>
                  <FiFileText size={32} style={{ color: '#00761F', opacity: 0.7 }} />
                </div>
              </div>
              
              <div style={{ 
                backgroundColor: 'white', 
                padding: '20px', 
                borderRadius: '12px', 
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                border: '1px solid #e0e0e0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#4CAF50' }}>
                      {applications.filter(app => app.paymentStatus === 'paid').length}
                    </div>
                    <div style={{ color: '#666', fontSize: '0.9rem' }}>Pagamentos Confirmados</div>
                  </div>
                  <FiCheck size={32} style={{ color: '#4CAF50', opacity: 0.7 }} />
                </div>
              </div>

              <div style={{ 
                backgroundColor: 'white', 
                padding: '20px', 
                borderRadius: '12px', 
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                border: '1px solid #e0e0e0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#FF9800' }}>
                      {applications.filter(app => app.paymentStatus === 'pending').length}
                    </div>
                    <div style={{ color: '#666', fontSize: '0.9rem' }}>Pagamentos Pendentes</div>
                  </div>
                  <FiClock size={32} style={{ color: '#FF9800', opacity: 0.7 }} />
                </div>
              </div>
            </div>

            {/* Filters */}
            <div style={{ 
              backgroundColor: 'white', 
              padding: '20px', 
              borderRadius: '12px', 
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              marginBottom: '20px',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', alignItems: 'center' }}>
                <div style={{ position: 'relative' }}>
                  <FiSearch size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#666' }} />
                  <input
                    type="text"
                    placeholder="Pesquisar candidaturas..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px 12px 12px 40px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      fontSize: '14px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
                
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  style={{
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '14px'
                  }}
                >
                  <option value="all">Todos os Status</option>
                  <option value="new">Novo</option>
                  <option value="approved">Aprovado</option>
                  <option value="rejected">Rejeitado</option>
                  <option value="pending">Pendente</option>
                </select>
                
                <select
                  value={paymentFilter}
                  onChange={(e) => setPaymentFilter(e.target.value)}
                  style={{
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '14px'
                  }}
                >
                  <option value="all">Todos os Pagamentos</option>
                  <option value="paid">Pago</option>
                  <option value="pending">Pendente</option>
                  <option value="overdue">Em Atraso</option>
                </select>
              </div>
            </div>

            {/* Applications Table */}
            <div style={{ 
              backgroundColor: 'white', 
              borderRadius: '12px', 
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                      <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Candidato</th>
                      <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Curso</th>
                      <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Data</th>
                      <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Status</th>
                      <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Pagamento</th>
                      <th style={{ padding: '15px', textAlign: 'center', fontWeight: '600', color: '#495057' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredApplications.map((app) => (
                      <tr key={app.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                        <td style={{ padding: '15px' }}>
                          <div>
                            <div style={{ fontWeight: '600', color: '#333' }}>{app.nomeCompleto}</div>
                            <div style={{ fontSize: '0.8rem', color: '#666' }}>{app.email}</div>
                          </div>
                        </td>
                        <td style={{ padding: '15px', color: '#495057' }}>{app.curso}</td>
                        <td style={{ padding: '15px', color: '#495057' }}>{formatDate(app.createdAt)}</td>
                        <td style={{ padding: '15px' }}>
                          <select
                            value={app.status}
                            onChange={(e) => handleUpdateApplicationStatus(app.id, e.target.value)}
                            style={{
                              padding: '6px 10px',
                              borderRadius: '6px',
                              border: `1px solid ${getStatusColor(app.status)}`,
                              backgroundColor: `${getStatusColor(app.status)}20`,
                              color: getStatusColor(app.status),
                              fontSize: '0.8rem',
                              fontWeight: '600'
                            }}
                          >
                            <option value="new">Novo</option>
                            <option value="approved">Aprovado</option>
                            <option value="rejected">Rejeitado</option>
                            <option value="pending">Pendente</option>
                          </select>
                        </td>
                        <td style={{ padding: '15px' }}>
                          <select
                            value={app.paymentStatus}
                            onChange={(e) => handleUpdatePaymentStatus(app.id, e.target.value)}
                            style={{
                              padding: '6px 10px',
                              borderRadius: '6px',
                              border: `1px solid ${getPaymentStatusColor(app.paymentStatus)}`,
                              backgroundColor: `${getPaymentStatusColor(app.paymentStatus)}20`,
                              color: getPaymentStatusColor(app.paymentStatus),
                              fontSize: '0.8rem',
                              fontWeight: '600'
                            }}
                          >
                            <option value="pending">Pendente</option>
                            <option value="paid">Pago</option>
                            <option value="overdue">Em Atraso</option>
                          </select>
                        </td>
                        <td style={{ padding: '15px', textAlign: 'center' }}>
                          <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                            <button
                              onClick={() => {setSelectedApplication(app); setShowApplicationModal(true);}}
                              style={{
                                padding: '8px',
                                border: 'none',
                                borderRadius: '6px',
                                backgroundColor: '#e3f2fd',
                                color: '#1976d2',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              title="Ver detalhes"
                            >
                              <FiEye size={16} />
                            </button>
                            <button
                              onClick={() => handlePrintReceipt(app)}
                              style={{
                                padding: '8px',
                                border: 'none',
                                borderRadius: '6px',
                                backgroundColor: '#e8f5e9',
                                color: '#00761F',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              title="Imprimir recibo"
                            >
                              <FiPrinter size={16} />
                            </button>
                            <button
                              onClick={() => handlePrintPaymentProof(app)}
                              style={{
                                padding: '8px',
                                border: 'none',
                                borderRadius: '6px',
                                backgroundColor: '#fff3e0',
                                color: '#f57c00',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              title="Comprovativo de pagamento"
                            >
                              <FiDownload size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'users' && currentUser.role === 'admin' && (
          <div>
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
              <div>
                <h1 style={{ color: '#333', margin: '0 0 10px 0', fontSize: '1.8rem' }}>Gestão de Utilizadores</h1>
                <p style={{ color: '#666', margin: 0 }}>Adicione e gerencie funcionários do sistema</p>
              </div>
              <button
                onClick={() => setShowUserModal(true)}
                style={{
                  backgroundColor: '#00761F',
                  color: 'white',
                  border: 'none',
                  padding: '12px 20px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontWeight: '500'
                }}
              >
                <FiPlus size={18} />
                Adicionar Utilizador
              </button>
            </div>

            {/* Users Table */}
            <div style={{ 
              backgroundColor: 'white', 
              borderRadius: '12px', 
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              border: '1px solid #e0e0e0'
            }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                    <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Nome</th>
                    <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Email</th>
                    <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Função</th>
                    <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Status</th>
                    <th style={{ padding: '15px', textAlign: 'center', fontWeight: '600', color: '#495057' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                      <td style={{ padding: '15px', color: '#333', fontWeight: '600' }}>{user.name}</td>
                      <td style={{ padding: '15px', color: '#495057' }}>{user.email}</td>
                      <td style={{ padding: '15px' }}>
                        <span style={{
                          padding: '6px 12px',
                          borderRadius: '6px',
                          backgroundColor: user.role === 'admin' ? '#e3f2fd' : '#f3e5f5',
                          color: user.role === 'admin' ? '#1976d2' : '#7b1fa2',
                          fontSize: '0.8rem',
                          fontWeight: '600'
                        }}>
                          {user.role === 'admin' ? 'Administrador' : 'Funcionário'}
                        </span>
                      </td>
                      <td style={{ padding: '15px' }}>
                        <span style={{
                          padding: '6px 12px',
                          borderRadius: '6px',
                          backgroundColor: user.active ? '#e8f5e9' : '#ffebee',
                          color: user.active ? '#2e7d32' : '#c62828',
                          fontSize: '0.8rem',
                          fontWeight: '600'
                        }}>
                          {user.active ? 'Ativo' : 'Inativo'}
                        </span>
                      </td>
                      <td style={{ padding: '15px', textAlign: 'center' }}>
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                          <button
                            onClick={() => setUsers(prev => prev.map(u => 
                              u.id === user.id ? {...u, active: !u.active} : u
                            ))}
                            style={{
                              padding: '8px',
                              border: 'none',
                              borderRadius: '6px',
                              backgroundColor: user.active ? '#ffebee' : '#e8f5e9',
                              color: user.active ? '#c62828' : '#2e7d32',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            title={user.active ? 'Desativar' : 'Ativar'}
                          >
                            {user.active ? <FiX size={16} /> : <FiCheck size={16} />}
                          </button>
                          <button
                            style={{
                              padding: '8px',
                              border: 'none',
                              borderRadius: '6px',
                              backgroundColor: '#e3f2fd',
                              color: '#1976d2',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            title="Editar"
                          >
                            <FiEdit3 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* Modal para Adicionar Usuário */}
      {showUserModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '500px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
          }}>
            <h2 style={{ color: '#333', marginBottom: '20px' }}>Adicionar Novo Utilizador</h2>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', color: '#495057', fontWeight: '500' }}>
                Nome Completo
              </label>
              <input
                type="text"
                value={newUser.name}
                onChange={(e) => setNewUser({...newUser, name: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  boxSizing: 'border-box'
                }}
                placeholder="Digite o nome completo"
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', color: '#495057', fontWeight: '500' }}>
                Email
              </label>
              <input
                type="email"
                value={newUser.email}
                onChange={(e) => setNewUser({...newUser, email: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  boxSizing: 'border-box'
                }}
                placeholder="Digite o email"
              />
            </div>

            <div style={{ marginBottom: '30px' }}>
              <label style={{ display: 'block', marginBottom: '8px', color: '#495057', fontWeight: '500' }}>
                Função
              </label>
              <select
                value={newUser.role}
                onChange={(e) => setNewUser({...newUser, role: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '14px',
                  boxSizing: 'border-box'
                }}
              >
                <option value="employee">Funcionário</option>
                <option value="admin">Administrador</option>
              </select>
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowUserModal(false)}
                style={{
                  padding: '12px 20px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  color: '#495057',
                  cursor: 'pointer',
                  fontWeight: '500'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleAddUser}
                style={{
                  padding: '12px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  backgroundColor: '#00761F',
                  color: 'white',
                  cursor: 'pointer',
                  fontWeight: '500'
                }}
              >
                Adicionar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para Ver Detalhes da Candidatura */}
      {showApplicationModal && selectedApplication && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '700px',
            maxHeight: '80vh',
            overflow: 'auto',
            boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
              <h2 style={{ color: '#333', margin: 0 }}>Detalhes da Candidatura</h2>
              <button
                onClick={() => setShowApplicationModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
              <div>
                <h3 style={{ color: '#00761F', marginBottom: '15px', fontSize: '1.1rem' }}>Informações Pessoais</h3>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Nome:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{selectedApplication.nomeCompleto}</div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Data de Nascimento:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{selectedApplication.dataNascimento}</div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Gênero:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{selectedApplication.genero}</div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Documento:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{selectedApplication.docIdentificacao}</div>
                </div>
              </div>

              <div>
                <h3 style={{ color: '#00761F', marginBottom: '15px', fontSize: '1.1rem' }}>Informações de Contato</h3>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Email:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{selectedApplication.email}</div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Telefone:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{selectedApplication.telefone}</div>
                </div>
              </div>

              <div>
                <h3 style={{ color: '#00761F', marginBottom: '15px', fontSize: '1.1rem' }}>Informações Acadêmicas</h3>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Curso:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{selectedApplication.curso}</div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Turno:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{selectedApplication.turno}</div>
                </div>
              </div>

              <div>
                <h3 style={{ color: '#00761F', marginBottom: '15px', fontSize: '1.1rem' }}>Status e Datas</h3>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Status:</strong>
                  <div style={{ 
                    color: getStatusColor(selectedApplication.status), 
                    marginTop: '2px',
                    fontWeight: '600'
                  }}>
                    {selectedApplication.status}
                  </div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Status de Pagamento:</strong>
                  <div style={{ 
                    color: getPaymentStatusColor(selectedApplication.paymentStatus), 
                    marginTop: '2px',
                    fontWeight: '600'
                  }}>
                    {selectedApplication.paymentStatus}
                  </div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Data de Inscrição:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{formatDate(selectedApplication.createdAt)}</div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#495057' }}>Última Atualização:</strong>
                  <div style={{ color: '#333', marginTop: '2px' }}>{formatDate(selectedApplication.updatedAt)}</div>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e9ecef' }}>
              <button
                onClick={() => handlePrintReceipt(selectedApplication)}
                style={{
                  padding: '12px 20px',
                  border: '1px solid #00761F',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  color: '#00761F',
                  cursor: 'pointer',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <FiPrinter size={16} />
                Imprimir Recibo
              </button>
              <button
                onClick={() => handlePrintPaymentProof(selectedApplication)}
                style={{
                  padding: '12px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  backgroundColor: '#00761F',
                  color: 'white',
                  cursor: 'pointer',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <FiDownload size={16} />
                Comprovativo de Pagamento
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;